<template>
  <div class="bg-background-0 flex h-full min-h-0 flex-col">
    <div v-if="$slots.header" class="bg-background-0 shrink-0">
      <slot name="header" />
    </div>

    <div class="min-h-0 grow">
      <slot />
    </div>

    <div v-if="$slots.footer" class="border-background-200 bg-background-0 shrink-0 border-t">
      <slot name="footer" />
    </div>
  </div>
</template>
